// angular
//     .module("HeroPRO")
//     .controller("JobNumberPopoverController", jobNumberPopoverController);

import _ from 'lodash';

/* @ngInject */
export default function jobNumberPopoverController(FRInformationFactory, $scope, $stateParams, JobNumberPopoverFactory) {
    const vm = this;
    vm.newJobNumber = '';

    init();

    /*= ========================================
	=            Private Functions            =
	========================================= */
    function init() {
        FRInformationFactory.getFundingRequestInformationPromise().then(() => {
            if (FRInformationFactory.getAppInfo().ContractorJobs !== undefined) {
                $scope.primaryInformation.contractorJobs = FRInformationFactory.getAppInfo().ContractorJobs;
                _.each($scope.primaryInformation.contractorJobs, (job) => {
                    job.editing = false;
                });
            }
        });
    }
    /*= ====  End of Private Functions  ====== */


    /*= =======================================
	=            Public Functions            =
	======================================== */
    vm.deleteContractorJob = function (contractorJob) {
        $scope.primaryInformation.contractorJobs = _.reject($scope.primaryInformation.contractorJobs, job => job.FundingRequestToContractorJobId === contractorJob.FundingRequestToContractorJobId);

        JobNumberPopoverFactory.deleteContractorJobNumber(contractorJob.FundingRequestToContractorJobId).then(() => {});
    };

    vm.addContractorJob = function (jobNumber, form) {
        if (jobNumber !== '') {
            const newJobNumber = {
                FundingRequestId: $stateParams.appId,
                ContractorSystemJobId: jobNumber,
                editing: false,
            };

            $scope.primaryInformation.contractorJobs.push(newJobNumber);
            vm.newJobNumber = '';
            form.newJobNumber.$setValidity('newJobNumber', true);

            JobNumberPopoverFactory.addEditContractorJobNumber(newJobNumber).then((response) => {
                $scope.primaryInformation.contractorJobs[$scope.primaryInformation.contractorJobs.length - 1].FundingRequestToContractorJobId = response.data.Data.FundingRequestToContractorJobId;
            });
        } else {
            form.newJobNumber.$setValidity('newJobNumber', false);
        }
    };

    vm.editContractorJob = function (contractorJob) {
        contractorJob.editing = true;
    };

    vm.saveContractorJob = function (contractorJob) {
        contractorJob.editing = false;
        JobNumberPopoverFactory.addEditContractorJobNumber(contractorJob);
    };
    /*= ====  End of Public Functions  ====== */
}



// WEBPACK FOOTER //
// ./src/app/common/primaryInformation/jobNumberPopoverController.js